export default "dist/images/block-header-side-overlay.f9eb78b.png";